import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {InlineSVGModule} from 'ng-inline-svg';
import {PatternListComponent} from './pattern-list/pattern-list.component';
import {PatternListItemComponent} from './pattern-list/pattern-list-item/pattern-list-item.component';
import {IonicModule} from '@ionic/angular';
import {BrowserModule} from '@angular/platform-browser';
import {RouterModule} from '@angular/router';
import {PatternPreviewComponent} from './pattern-preview/pattern-preview.component';

@NgModule({
    imports: [
        RouterModule,
        CommonModule,
        InlineSVGModule.forRoot(),
        IonicModule.forRoot()
    ],
    declarations: [PatternListComponent, PatternListItemComponent, PatternPreviewComponent],
    exports: [PatternListComponent, PatternListItemComponent, PatternPreviewComponent]
})
export class PatternsModule {
}
